import { SET_CURRENCY } from './constants';
import { CurrencyActions, CurrencyReducer } from './types';

const initState: CurrencyReducer = {};

export default (state = initState, action: CurrencyActions): CurrencyReducer => {
  switch (action.type) {
    case SET_CURRENCY: {
      return {
        ...state,
        [action.payload.currency.currency]: {
          code: action.payload.currency.code,
          decimals: action.payload.currency.decimals,
          currency: action.payload.currency.currency,
        },
      };
    }
    default:
      return state;
  }
};
